import React from 'react';
import { useLocation } from 'react-router-dom';
import AccountRestrictedPanel from './AccountRestrictedPanel';
import { useUserAccessFlags } from '../../hooks/useUserAccessFlags';
import { isSuspendedAllowedPath } from '../../utils/userAccessFlags';

/** When blocked, the Account Restricted panel replaces the route — that screen never mounts. */
function RestrictedRouteGate({ blocked, reason, children }) {
  if (!blocked) return children;
  return <AccountRestrictedPanel reason={reason} />;
}

/**
 * Suspended: sidebar + header stay visible; only Support is reachable. Any other route
 * (menu click, typed URL, bookmark, refresh) shows the Account Restricted panel instead.
 */
export function SuspendAccessGate({ children }) {
  const { isSuspended, suspendedReason } = useUserAccessFlags();
  const location = useLocation();
  const blocked = Boolean(isSuspended) && !isSuspendedAllowedPath(location.pathname);
  return (
    <RestrictedRouteGate blocked={blocked} reason={suspendedReason}>
      {children}
    </RestrictedRouteGate>
  );
}
